<template>
  <div id="berkas">
    <BreadcrumbStep />

    <h5 class="my-5 text-center">
      <i class="fa fa-upload text-primary mr-2" />Upload Berkas
    </h5>

    <div class="card card-primary">
      <div class="card-header">
        <h4>Upload Berkas Persyaratan</h4>
      </div>
      <div class="card-body p-0">
        <div
          class="alert alert-light alert-has-icon mx-3"
          v-if="dataPermohonan.id_data_permohonan"
        >
          <div class="alert-icon">
            <i class="far fa-lightbulb" />
          </div>
          <div class="alert-body">
            <div class="alert-title">
              Syarat Permohonan {{ dataPermohonan.paket_layanan.layanan.nama }}
            </div>
            Lengkapi berkas sesuai persyaratan untuk dapat mengajukan permohonan<br>
            <b-button
              v-b-toggle.collapse-syarat
              variant="primary"
              size="sm"
              class="mt-2"
            >
              <i class="fa fa-eye mr-2" />Buka/Tutup Syarat
            </b-button>
            <b-collapse
              id="collapse-syarat"
              visible
              class="mt-2"
            >
              <table>
                <tr
                  v-for="s in syarat"
                  :key="s.id_layanan_dokumen"
                >
                  <td>
                    <i
                      v-if="s.is_completed"
                      class="fa fa-check-circle text-success pr-2"
                    />
                    <i
                      v-else
                      class="fa fa-times text-danger pr-2"
                    />
                  </td>
                  <td>
                    {{ s.dokumen.nama_dokumen }}
                    <b v-if="s.is_harus_diisi == 1">(wajib)</b>
                    <i v-if="s.keterangan">({{ s.keterangan }})</i>
                  </td>
                </tr>
              </table>
            </b-collapse>
          </div>
        </div>
        <div class="table-responsive">
          <ListBerkas />
        </div>
      </div>
    </div>
    <div
      class="card card-primary mt-3"
      v-if="is_lengkap"
    >
      <div class="card-header">
        <h4>Ajukan Permohonan</h4>
      </div>
      <div class="card-body">
        <div class="alert alert-success alert-has-icon">
          <div class="alert-icon">
            <i class="fas fa-check-circle" />
          </div>
          <div class="alert-body">
            <div class="alert-title">
              Permohonan Anda Sudah Siap untuk Diajukan
            </div>
            Permohonan yang sudah diajukan tidak dapat diedit kembali, kecuali permintaan validator (desa/dukcapil).
          </div>
        </div>

        <div class="form-group row mt-5">
          <label
            for=""
            class="col-sm-3 text-sm-right"
          >Tambahkan Keterangan</label>
          <div class="col-sm-9">
            <textarea
              class="form-control"
              rows="10"
              v-model="keterangan_tambahan"
            />
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-9 offset-sm-3">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="customCheck1"
                v-model="is_konfirmasi"
              >
              <label
                class="custom-control-label"
                for="customCheck1"
              >Saya menyatakan data permohonan sudah benar adanya</label>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-9 offset-sm-3">
            <button
              class="btn btn-primary"
              @click="ajukanPermohonan($event)"
              :disabled="!is_konfirmasi"
            >
              <i class="fa fa-check mr-2" />Ajukan Permohonan
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card card-primary mt-3"
      v-else
    >
      <div class="card-header">
        <h4>Ajukan Permohonan</h4>
      </div>
      <div class="card-body">
        <div class="alert alert-danger alert-has-icon">
          <div class="alert-icon">
            <i class="fas fa-info-circle" />
          </div>
          <div class="alert-body">
            <div class="alert-title">
              Permohonan Belum Lengkap
            </div>
            Terdapat berkas wajib yang belum di-upload. Pastikan semua berkas wajib sudah bertanda centang hijau pada checklist syarat.
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6 pr-0">
        <button
          id="btnKembali"
          class="btn btn-danger"
          @click="setStep(4)"
        >
          <i class="fa fa-angle-left mr-2" />Kembali
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
    .card-item.card {
        cursor: pointer;
    }
    .card-item.card.active, .card-item.card:hover {
        border:1px solid #007bff
    }
</style>

<script>
import swal from 'sweetalert'
import ListBerkas from './../../components/global/ListBerkas.vue'
import BreadcrumbStep from './BreadcrumbStep.vue'

export default {
    data() {
        return {
            syarat: null,
            keterangan_tambahan: '',
            is_konfirmasi: false,
            is_lengkap: false,
        }
    },
    computed: {
        dataPermohonan(){
            return this.$store.getters.getDataPermohonan
        },
        layananSelected(){
            return this.$store.getters.getLayananSelected
        },
        filePermohonan(){
            return this.$store.getters.getFilePermohonan
        },
        namaRole(){
            return this.$store.getters.getAuthService.currentRole.nama_role
        }
    },
    components: {
        ListBerkas, BreadcrumbStep
    },
    methods: {
        checkListSyarat(){
            this.syarat = null

            let syarat = this.layananSelected.layanan_dokumen

            // jika isi formulir online, form tidak wajib untuk diupload
            if(this.dataPermohonan.is_form_online === 1){
                syarat.forEach(e => {
                    if(e.dokumen.is_form === 1){
                        e.is_harus_diisi = 2 // 2 artinya tidak wajib karena sudah isi form online
                    }
                })
            }
            

            let numSyaratWajib = this.layananSelected.layanan_dokumen.filter(e => e.is_harus_diisi === 1)
            numSyaratWajib = numSyaratWajib.length
            // console.log('numSyaratWajib', numSyaratWajib)
            let numFileWajib = 0

            // console.log('this.filePermohonan.findIndex(f => f.id_dokumen === 9', this.filePermohonan.findIndex(f => f.id_dokumen === 9))

            syarat.forEach(e => {
                if(this.filePermohonan.findIndex(f => f.id_dokumen === e.id_dokumen) > -1){
                    e.is_completed = true
                } else {
                    e.is_completed = false
                }
            })

            this.filePermohonan.forEach(e => {
                if(syarat.find(f => f.id_dokumen === e.id_dokumen).is_harus_diisi === 1){
                    numFileWajib += 1
                }
            })

            // console.log('numFileWajib', numFileWajib)

            this.syarat = syarat

            // console.log(this.syarat)

            if(numSyaratWajib === numFileWajib){
                this.is_lengkap = true
            } else {
                this.is_lengkap = false
            }
            // console.log(this.syarat)
        },
        notify(data){
			let formData = new FormData
            for(let key in data){
                formData.append(key, data[key])
            }

            this.$store.dispatch('sendNotifikasi', formData).then(r => {
				// console.log(r)
			})
        },
        ajukanPermohonan(e){
            // console.log(this.layananSelected)
            let button = e.target
            let buttonHtml = button.innerHTML
            
            button.setAttribute('disabled', true)
            button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Ajukan Permohonan'

            let statusDiajukan = 1 // ini berdasarkan setting validasi layanan

            if(this.layananSelected.paket_layanan.is_valid_desa == 1){
                statusDiajukan = 1
            }

            if(this.layananSelected.paket_layanan.is_valid_desa == 0 && this.layananSelected.paket_layanan.is_valid_kecamatan == 1){
                statusDiajukan = 5
            }

            if(this.layananSelected.paket_layanan.is_valid_desa == 0 && this.layananSelected.paket_layanan.is_valid_kecamatan == 0 &&
                this.layananSelected.paket_layanan.is_valid_dukcapil == 1 ){
                statusDiajukan = 9
            }

            let formData = new FormData()
            formData.append('tahap', 6)
            formData.append('keterangan_pemohon', (this.keterangan_tambahan) ? this.keterangan_tambahan : '-')
            formData.append('status', statusDiajukan)
            formData.append('id_paket_layanan', this.layananSelected.paket_layanan.id_paket_layanan)

            let role = this.$store.getters.getAuthService.currentRole.nama_role
            if(role === 'Operator Desa' || role === 'Kepala Desa' || role === 'Rumah Sakit'){
                formData.append('is_operator_desa', 1)
            }

            let idDataPermohonan = this.dataPermohonan.id_data_permohonan

            this.$store.dispatch('updatePermohonanPenduduk', {id: idDataPermohonan, form: formData}).then(res => {
                if(res.data.status){
                    let resetDataPermohonan = {
                        tahap: 1
                    }
                    this.$store.dispatch('setDataPermohonan', resetDataPermohonan)

                    // send notif ke operator dukcapil
                    this.notify({
                        type_notif: 'STATUS_PERMOHONAN',
                        type_receiver: 'operator_dukcapil',
                        id_data_permohonan: idDataPermohonan,
                        status_permohonan: 1,
                        via: 'mail,fcm',
                        title_notif: `Ada Pengajuan Permohonan Baru`,
                        body_notif: `Permohonan ${this.layananSelected.nama_layanan} oleh ${this.$store.getters.getUserProfile.nama_lengkap}`
                    })
                    this.$router.push({path: `/permohonan/detail-permohonan/${idDataPermohonan}`})
                    
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
            }).catch(err => {
                switch(err.response.status){
                    case 500:
                        this.$router.push({path: '/500'})
                        break;

                    case 400:
                        swal({
                            title: "Gagal",
                            text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                    
                    default:
                        swal({
                            title: "Gagal",
                            text: err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                }
            })
        },
        setStep(val){
            let setStatus = val
            let updateIsFormOnline = false // jika sekarang form manual, klik kembali berarti ke pengisian formulir. supaya bisa memilih online/manual lagi

            let dataPermohonan = this.$store.getters.getDataPermohonan
            let idDataPermohonan = dataPermohonan.id_data_permohonan


            // is_form_online: 0 belum milih, 1 online, 2 manual
            if(dataPermohonan.is_form_online === 1){
                setStatus = 4
            } else if(dataPermohonan.is_form_online === 2){
                setStatus = 3
                updateIsFormOnline = true
            } else if(dataPermohonan.is_form_online === 0){
                setStatus = 3
                updateIsFormOnline = true
            }
            let button = document.querySelector('#btnKembali')
            let buttonHtml = button.innerHTML

            button.setAttribute('disabled', true)
            button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Kembali'

            

            let formDataPermohonan = new FormData()
            formDataPermohonan.append('tahap', setStatus)
            formDataPermohonan.append('id_paket_layanan', this.layananSelected.paket_layanan.id_paket_layanan)

            if(updateIsFormOnline){
                formDataPermohonan.append('is_form_online', 0)
            }

            let role = this.$store.getters.getAuthService.currentRole.nama_role
            if(role === 'Operator Desa'){
                formDataPermohonan.append('is_operator_desa', 1)
            }

            this.$store.dispatch('updatePermohonanPenduduk', {id: idDataPermohonan, form: formDataPermohonan}).then(res => {
                if(res.data.status){
                    let dispatch = 'showDataPermohonanPenduduk'
                    if(this.namaRole == 'Penduduk'){
                        dispatch = 'showDataPermohonanPenduduk'
                    } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
                        dispatch = 'showDataPermohonanPendudukByDesa'
                    } else if(this.namaRole == 'Operator Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByKecamatan'
                    } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByDukcapil'
                    } else if(this.namaRole == 'Rumah Sakit'){
                        dispatch = 'showDataPermohonanPendudukByRumahSakit'
                    }
                    
                    this.$store.dispatch(dispatch, idDataPermohonan)
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
                button.removeAttribute('disabled')
                button.innerHTML = buttonHtml
            }).catch(err => {
                switch(err.response.status){
                    case 500:
                        this.$router.push({path: '/500'})
                        break;

                    case 400:
                        swal({
                            title: "Gagal",
                            text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                    
                    default:
                        swal({
                            title: "Gagal",
                            text: err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                }
                button.removeAttribute('disabled')
                button.innerHTML = buttonHtml
            })

        },
    },
    mounted(){
        // console.log(this.layananSelected)
        if(this.dataPermohonan.status != 0){
            this.$store.dispatch('setIsResetPermohonan', true)
            let resetDataPermohonan = {
                tahap: 1
            }
            this.$store.dispatch('setDataPermohonan', resetDataPermohonan)
        }
    },
    watch: {
        filePermohonan(newVal){
            // console.log('file permohonan change', newVal)
            this.checkListSyarat()
        }
    }
}
</script>